import type { ComponentType } from "react";
import type { Conference } from "./api.js";
import { AttendeesStage } from "./conference/stages/AttendeesStage.js";
import { CollectStage } from "./conference/stages/CollectStage.js";
import { CommunicateStage } from "./conference/stages/CommunicateStage.js";
import { DecideStage } from "./conference/stages/DecideStage.js";
import { PublishStage } from "./conference/stages/PublishStage.js";
import { ProgrammeStage } from "./conference/stages/ProgrammeStage.js";
import { ReviewStage } from "./conference/stages/ReviewStage.js";
import { SettingsStage } from "./conference/stages/SettingsStage.js";

type StageProps = { conference: Conference };

const legacyStage: Record<string, string> = {
  submissions: "collect", reviews: "review", decisions: "decide",
  registration: "attendees", website: "publish",
  emails: "communicate", exports: "settings", advanced: "settings", billing: "settings",
};

const stageBySection: Record<string, ComponentType<StageProps>> = {
  collect: CollectStage, review: ReviewStage, decide: DecideStage, programme: ProgrammeStage, publish: PublishStage,
  attendees: AttendeesStage, communicate: CommunicateStage, settings: SettingsStage,
};

export function resolveConferenceStage(section: string) { return legacyStage[section] ?? section; }

export function ConferenceWorkspacePreview({ conference, section }: { conference: Conference; section: string }) {
  const Stage = stageBySection[resolveConferenceStage(section)] ?? CollectStage;
  return <Stage conference={conference} />;
}
